<template>
  <div class="fees">
    <el-row class="fee-title">
      <el-col :span="3">
        <span class="h3">费用账单</span>
      </el-col>
    </el-row>
    <div class="fee-info">
      <el-row class="fee-bean-info" type="flex" justify="center">
        <el-col :span="8" class="fee-base-info grid-content">
          <div>
            <p class="base-info-title">设备合计</p>
            <p class="base-info-value">{{(workDevice + unWorkDevice) | I1000}}</p>
          </div>
        </el-col>
        <el-col :span="8" class="fee-base-info grid-content">
          <div>
            <p class="base-info-title">计费设备数(截止今日)</p>
            <p class="base-info-value">{{workDevice | I1000}}</p>
          </div>
        </el-col>
        <el-col :span="8" class="fee-base-info grid-content not-right">
          <div>
            <p class="base-info-title">停机设备数(截止今日)</p>
            <p class="base-info-value">{{unWorkDevice | I1000}}</p>
          </div>
        </el-col>

      </el-row>
      <div class="chart-line-realtime">
        <el-row type="flex" justify="center">
          <el-col :span="6" class="item-title">
                        <span class="item-title-info">
                            费用分布
                        </span>
          </el-col>

          <el-col :span="8" :offset="10">
            <span class="look-bill" @click="showList = !showList">切换账期</span>
            <span class="item-label">账期时间: </span>
            <el-date-picker
              size="mini"
              :format="dateFmt"
              v-model="date"
              :type="type"
              @change="handleChange"
              placeholder="选取日期">
            </el-date-picker>
            <span class="time" :class="type==='year'?'active':'' " @click="handleChangeLabel('year')">年</span>
            <span class="time" :class="type==='month'?'active':'' " @click="handleChangeLabel('month')">月</span>
          </el-col>
        </el-row>
        <charts class="fee-chart" v-show="!showList" ref="feeChart"></charts>
        <list v-if="showList" :data="data" :date="this.date"></list>

      </div>

    </div>
  </div>

</template>

<script>
  import Charts from './charts'
  import List from './list'

  import {billDevices, billAnalyze} from '@/api/factory/bill'

  export default {
    name: '',
    components: {
      Charts,
      List
    },
    mounted: function () {
      this.date = new Date()

      billDevices().then(res => {
        this.workDevice = res.data.deviceUnlock
        this.unWorkDevice = res.data.deviceLock
      })

      this.loadAnalyze()
    },
    data: function () {
      return {
        dateFmt: 'yyyy',
        date: '',
        type: 'year',
        workDevice: 0,
        unWorkDevice: 0,
        showList: false,
        dateTime: '',
        data: []
      }
    },
    filters: {
      filterName(status) {
        switch (status) {
          case 0:
            return '离线'
          case 1:
            return '正常运行'
          case 2:
            return '待维护'
          case 3:
            return '待维修'
        }
      },
    },
    methods: {
      handleChangeLabel(value) {
        this.type = value
        switch (value) {
          case "year":
            this.dateFmt = 'yyyy'
            break;
          case "month":
            this.dateFmt = 'yyyy-MM'
            break;
        }
        this.loadAnalyze()
      },

      getDaysOfMonth(year, month) {
        var date = new Date(year, month, 0);
        var days = date.getDate();
        return days;
      },

      loadAnalyze() {
        billAnalyze({
          year: this.date.getFullYear(),
          month: this.date.getMonth() + 1,
          type: this.type === 'year' ? 0 : 1
        }).then(res => {
          let dataLen = 12
          let unit = `月`
          if (this.type === `month`) {
            dataLen = this.getDaysOfMonth(this.date.getFullYear(), this.date.getMonth() + 1);
            unit = `天`
          }

          this.data = res.data || []

          this.$refs.feeChart.setData(dataLen, unit, this.type, res.data || [])

        })
      },
      handleChange(value) {
        this.loadAnalyze()
      },
      handleAreaChange(value) {
        console.log(value)
      }
    },
  }
</script>

<style lang="scss">
  .el-date-picker__header--bordered {
    border-bottom: 1px solid $border_th_color;
  }

  .fees {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .fee-title {
      .fee-input-filter {
        input {
          border: none;
          border-bottom: 1px solid $f_fiv_color;
          font-size: $filter-font-size;
          border-radius: 0;
        }
      }
    }

    .fee-info {
      padding: $padding;
      flex: 1;
      display: flex;
      flex-direction: column;

      .time {
        border: 1px solid $f_color;
        padding: 2px;
        border-radius: 2px;
        margin-right: 8px;
        font-size: 12px;
        cursor: pointer;
      }

      .time.active, .time:hover {
        background-color: $f_color;
        color: #1f232b;
      }

      .item-title {
        font-size: .8rem;
        font-weight: 600;
        display: table;
        margin: auto 0;
        color: $f_sec_color;

        .item-title-info {
          display: table-cell;
          vertical-align: middle;
        }

      }

      .look-bill {
        font-weight: normal;
        font-size: .6rem;
        cursor: pointer;
        display: inline-block;
        margin-right: $padding-5;
      }

      .item-label {
        font-size: .6rem;
        color: $f_sec_color;
      }

      .fee-bean-info {
        padding: $padding;
        background-color: $bg_sec_color;
        margin-top: $padding;
        border-radius: .5rem;
        /*text-align: center;*/

        * {
          color: $f_sec_color;
        }


        .grid-content {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .fee-info-text {
          border-right: 1px solid $border_th_color;
          padding-left: $padding-5;
        }

        .fee-base-info {
          text-align: center;
          border-right: 1px solid $border_th_color;

          .base-info-title {
            font-size: .8rem;
          }

          .base-info-value {
            margin: $padding-5;
            font-size: 1rem;
            font-weight: $w1;

          }

          .base-info-mark {
            font-size: .6rem;
          }
        }

        .not-right {
          border: none;
        }

        .fee-bean-col {
          font-size: .6rem;

          .info-text {
            font-weight: $w1;
          }

          .look-record {
            display: inline-block;
            margin-left: $padding-5;
            color: $f_color;
          }
        }
      }

      .chart-line-realtime {
        padding: $padding;
        background-color: $bg_sec_color;
        margin-top: $padding;
        border-radius: .5rem;

        .el-date-editor {
          background-color: transparent;
        }

        .fee-chart {
          height: 20rem;
        }
      }
    }
  }

</style>
